import { Button } from "react-bootstrap";
import { FaCheck, FaPaperPlane, FaClock, FaThumbsUp, FaTimes } from "react-icons/fa";

const TaskActionButton = ({ status, handleAction }) => {
  let variant = "primary";
  let text = "";
  let icon = null;
  let disabled = false;

  switch (status) {
    case "pending":
      variant = "primary";
      text = "Topshiriqni qabul qilish";
      icon = <FaCheck className="ms-2" />;
      break;

    case "in_progress":
      variant = "success";
      text = "Yuborish";
      icon = <FaPaperPlane className="ms-2" />;
      break;

    case "submitted":
      variant = "secondary";
      text = "Tasdiqlanishi kutilmoqda";
      icon = <FaClock className="ms-2" />;
      disabled = true;
      break;

    case "approved":
      variant = "success";
      text = "Tasdiqlandi";
      icon = <FaThumbsUp className="ms-2" />;
      disabled = true;
      break;

    case "rejected":
      variant = "danger";
      text = "Rad etildi";
      icon = <FaTimes className="ms-2" />;
      disabled = true;
      break;

    default:
      variant = "secondary";
      text = "Noma'lum";
      disabled = true;
  }

  return (
    <Button style={{textTransform: 'none'}} className="d-flex align-items-center ms-auto" variant={variant} onClick={handleAction} disabled={disabled}>
      {text}
      {icon}
    </Button>
  );
};

export default TaskActionButton;
